import React from 'react';
import { Box, Typography, BoxProps } from '@mui/material';

// Define the props type
type CircularIconLayoutProps = BoxProps; // This will include all props of the Box component

const icons = [
  'py1.webp',
  'js2.png',
  'dj.png', // Django
  'ds1.jpg',
  'aws.jpg',
  'rh.png',
  'cisco.webp',
  'azure.webp',
];

const CircularIconLayout: React.FC<CircularIconLayoutProps> = (props) => {
  return (
    <Box
    {...props} // Spread props to apply sx and other props
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
       
      }}
    >
      {/* Center circle with text */}
      <Box
        sx={{
          position: 'absolute',
          width: '150px',
          height: '150px',
          backgroundColor: 'white',
          borderRadius: '50%',
          zIndex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
        className='component'
      >
        <Typography variant="h2" sx={{ fontWeight: 'bold', fontSize: '20px' }} className='component'>
          100+ tools
        </Typography>
      </Box>

      {/* Icons positioned in a circular path */}
      <Box
        sx={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          animation: 'rotate 7s infinite linear',
          transformOrigin: 'center',
        }}
      >
        <Box
          component="img"
          src={icons[0]}
          alt="Python"
          sx={{
            position: 'absolute',
            top: '0',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
        <Box
          component="img"
          src={icons[1]}
          alt="JavaScript"
          sx={{
            position: 'absolute',
            top: '20%',
            left: '85%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
        <Box
          component="img"
          src={icons[2]}
          alt="Django"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '100%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
        <Box
          component="img"
          src={icons[3]}
          alt="Data Science"
          sx={{
            position: 'absolute',
            top: '80%',
            left: '85%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
        <Box
          component="img"
          src={icons[4]}
          alt="AWS"
          sx={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
        <Box
          component="img"
          src={icons[5]}
          alt="RedHat"
          sx={{
            position: 'absolute',
            top: '80%',
            left: '15%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
        <Box
          component="img"
          src={icons[6]}
          alt="Cisco"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '0%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
        <Box
          component="img"
          src={icons[7]}
          alt="Azure"
          sx={{
            position: 'absolute',
            top: '20%',
            left: '15%',
            transform: 'translate(-50%, -50%)',
            width: '70px',
            height: '70px',
            borderRadius:"50%"
          }}
        />
      </Box>

      <style>{`
        @keyframes rotate {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </Box>
  );
};

export default CircularIconLayout;
